import { Controller } from '@hotwired/stimulus'
import * as Turbo from '@hotwired/turbo'

const TAB_ID = 'assessment'

export default class extends Controller {
  sync (): void {
    const src = (this.element as HTMLElement & { src?: string }).src

    if (src === undefined || src === '') return
    if (!this.onAssessmentTab()) return

    const url = new URL(src, location.origin)
    url.searchParams.set('tab', TAB_ID)
    url.hash = ''

    Turbo.navigator.history.replace(url)

    const tab = document.getElementById(TAB_ID) as HTMLAnchorElement | null
    if (tab != null) tab.href = url.toString()
  }

  private onAssessmentTab (): boolean {
    return location.hash === `#${TAB_ID}` ||
      new URLSearchParams(location.search).get('tab') === TAB_ID
  }
}
